module.exports = __webpack_public_path__ + "static/media/Dashboard_jb_hunt.2b79ef05.png";